export class VehicleManufacturerDto {

  public id!: string;
  public name!: string;
  public typeId!: string;

  constructor(init?: Partial<VehicleManufacturerDto> | undefined) {
    Object.assign(this, init);
  }
}
